module.exports = __webpack_public_path__ + "img/Einschulung.46d5114a.svg";